import * as tslib_1 from "tslib";
import common from '../../../../../../common/pc';
import { ReverseRelevanceControl } from "../../../../../../form/src/common/controls/reverse-relevance-control";
import { Component } from "vue-property-decorator";
import ReverseRelevanceList from "./reverse-relevance-list.vue";
import ReverseRelevanceTabs from "./reverse-relevance-tabs.vue";
let ReverseRelevance = class ReverseRelevance extends ReverseRelevanceControl {
};
ReverseRelevance = tslib_1.__decorate([
    Component({
        name: "reverse-relevance",
        components: {
            ReverseRelevanceList,
            ReverseRelevanceTabs,
            H3Panel: common.components.Panel,
        }
    })
], ReverseRelevance);
export default ReverseRelevance;
